import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

import React, { useState } from 'react';
import { BrowserRouter } from 'react-router-dom';

import AppRoutes from './routes';
import { AuthProvider } from './services/auth-context.service';
import { LoggerProvider } from './services/logger-context.service';

const queryClient = new QueryClient({});

function App() {
  const [openSidebar, setOpenSidebar] = useState<boolean>(true);

  const toggleSidebar = () => {
    console.log('toggleSidebar called. Previous state:', openSidebar);
    setOpenSidebar((prev) => {
      console.log('New state:', !prev);
      return !prev;
    });
  };

  return (
    <LoggerProvider>
      <BrowserRouter>
        <QueryClientProvider client={queryClient}>
          <AuthProvider>
            <AppRoutes
              openSidebar={openSidebar}
              toggleSidebar={toggleSidebar}
            />
          </AuthProvider>
        </QueryClientProvider>
      </BrowserRouter>
    </LoggerProvider>
  );
}

export default App;
